import request from "@/utils/request";

export const getPushToken = () => {
  return request({
    url: '/message-center/token',
    baseURL: process.env.VUE_APP_TP_URL,
    method: "get",
    headers: {
      "portal-token": false,
    },
  });
};
